export const ROUTE_CHANGE = 'Route Change'
export const defaultErrorMessage = 'Oops! Unexpected Error Occured'
